/*
 * @Author: your name
 * @Date: 2021-05-06 11:35:31
 * @LastEditTime: 2021-05-06 15:49:59
 * @LastEditors: Please set LastEditors
 * @Description: 常用语句api
 * @FilePath: /dsicm-admin-web/src/views/treatment/api/overoutApi.js
 */
import request from '@/utils/req.js';

// 获取常用语句列表
export function getOveroutList(params) {
    return request.post("/admin/common-word/myList",params);
}
// 添加常用语句列表
export function addOverout(params) {
    return request.post("/admin/common-word",params);
}
// 编辑常用语句列表
export function updateOverout(params) {
    return request.put("/admin/common-word",params);
}
// 删除常用语句列表
export function deleteOverout(params) {
    return request.delete(`/admin/common-word/${params}`);
}